module.exports = __webpack_public_path__ + "img/zen-pond.7aad0384.webp";